export const XRPL_NETWORK = process.env.REACT_APP_XRPL_NETWORK || 'mainnet'

export const XRPL_WS_URL =
  process.env.REACT_APP_XRPL_WS ||
  (XRPL_NETWORK === 'mainnet' ? 'wss://xrplcluster.com' : 'wss://s.altnet.rippletest.net:51233')

export const XRPL_EXPLORER_BASE =
  process.env.REACT_APP_XRPL_EXPLORER_BASE ||
  (XRPL_NETWORK === 'mainnet' ? 'https://xrpscan.com/tx/' : 'https://testnet.xrpl.org/transactions/')

export const XUMM_API_BASE = process.env.REACT_APP_XUMM_API_BASE || process.env.XUMM_API_BASE || ''
export const XUMM_API_KEY = process.env.REACT_APP_XUMM_API_KEY || process.env.XUMM_API_KEY || ''
export const FARMS_API_BASE = process.env.REACT_APP_FARMS_API_BASE || ''
export const FARMS_SIGNAL_ADDRESS =
  process.env.REACT_APP_FARMS_SIGNAL_ADDRESS || process.env.REACT_APP_BESC_ISSUER || ''
export const FARMS_ESCROW_ADDRESS =
  process.env.REACT_APP_FARMS_ESCROW_ADDRESS || process.env.REACT_APP_FARMS_SIGNAL_ADDRESS || ''
export const FARMS_ACTION_FEE_DROPS = process.env.REACT_APP_FARMS_ACTION_FEE_DROPS || '1'

export const getXrplTxUrl = (hash: string) => `${XRPL_EXPLORER_BASE}${hash}`

const DEFAULT_BITHOMP_BASE =
  typeof window !== 'undefined' ? '/bithomp/api/v2/' : 'https://bithomp.com/api/v2/'

export const BITHOMP_API_BASE = process.env.REACT_APP_BITHOMP_API_BASE || DEFAULT_BITHOMP_BASE
export const BITHOMP_API_KEY = process.env.REACT_APP_BITHOMP_API_KEY || ''
export const BITHOMP_API_KEY_HEADER = process.env.REACT_APP_BITHOMP_API_KEY_HEADER || 'x-bithomp-token'
export const BITHOMP_TOKENS_PATH = process.env.REACT_APP_BITHOMP_TOKENS_PATH || 'trustlines/tokens'
export const BITHOMP_TOKENS_QUERY =
  process.env.REACT_APP_BITHOMP_TOKENS_QUERY ||
  'statistics=true&convertCurrencies=usd&currencyDetails=true&limit=100&order=rating'
export const BITHOMP_TOKENS_SEARCH_PATH =
  process.env.REACT_APP_BITHOMP_TOKENS_SEARCH_PATH || 'trustlines/tokens/search'
export const BITHOMP_TOKEN_PATH = process.env.REACT_APP_BITHOMP_TOKEN_PATH || 'trustlines/token'
export const BITHOMP_TOKEN_QUERY =
  process.env.REACT_APP_BITHOMP_TOKEN_QUERY || 'statistics=true&convertCurrencies=usd'

const DEFAULT_XRPSCAN_BASE =
  typeof window !== 'undefined' ? '/xrpscan/api/v1/' : 'https://api.xrpscan.com/api/v1/'
export const XRPSCAN_API_BASE = process.env.REACT_APP_XRPSCAN_API_BASE || DEFAULT_XRPSCAN_BASE

const DEFAULT_RIPPLE_DATA_BASE =
  typeof window !== 'undefined' ? '/ripple-data/v2/' : 'https://data.ripple.com/v2/'
export const RIPPLE_DATA_API_BASE = process.env.REACT_APP_RIPPLE_DATA_API_BASE || DEFAULT_RIPPLE_DATA_BASE

export const BITHOMP_AMMS_PATH = process.env.REACT_APP_BITHOMP_AMMS_PATH || 'amms'
export const BITHOMP_AMMS_QUERY = process.env.REACT_APP_BITHOMP_AMMS_QUERY || 'holders=true'
export const BITHOMP_AMMS_SEARCH_PATH = process.env.REACT_APP_BITHOMP_AMMS_SEARCH_PATH || 'amms/search'

export const BITHOMP_TRANSACTIONS_PATH = process.env.REACT_APP_BITHOMP_TRANSACTIONS_PATH || 'transactions'
export const BITHOMP_TRANSACTIONS_QUERY =
  process.env.REACT_APP_BITHOMP_TRANSACTIONS_QUERY || 'limit=20&relevantOnly=true&excludeFailures=true'
export const BITHOMP_WHALE_PATH = process.env.REACT_APP_BITHOMP_WHALE_PATH || 'transactions/whale'
export const BITHOMP_WHALE_RECEIVERS_PATH =
  process.env.REACT_APP_BITHOMP_WHALE_RECEIVERS_PATH || 'transactions/whale/receivers'
export const BITHOMP_WHALE_SENDERS_PATH =
  process.env.REACT_APP_BITHOMP_WHALE_SENDERS_PATH || 'transactions/whale/senders'
export const BITHOMP_WHALE_SUBMITTERS_PATH =
  process.env.REACT_APP_BITHOMP_WHALE_SUBMITTERS_PATH || 'transactions/whale/submitters'
